import React from "react";
import { Link } from "../layouts/menus/link";
import Logo from "../assets/logo.png";

export const NotFound = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center">
      <img src={Logo} alt="404" className="mb-4" width={150} />
      <h4 className="font-medium text-base mb-4">Cette page n'existe pas.</h4>
      <Link className="hover:underline text-gray-600" to="/">
        retourner à l'accueil &rarr;
      </Link>
    </div>
  );
};
